import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/vk_ts_line.png'


const _hoisted_1 = { class: "main-page-container" }
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = { class: "lft" }
const _hoisted_4 = { class: "left-box" }
const _hoisted_5 = { class: "vking-logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "item-left" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  class: "remote-name",
  style: {"color":"#fff","font-size":"14px"}
}
const _hoisted_13 = { style: {"color":"#fff","font-size":"14px"} }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "multi-device-content" }
const _hoisted_16 = { class: "model-footer" }
const _hoisted_17 = { class: "model-footer" }
const _hoisted_18 = {
  key: 2,
  class: "remote-setting-fullscreen"
}
const _hoisted_19 = { class: "remote-setting-header" }
const _hoisted_20 = { class: "remote-setting-content" }
const _hoisted_21 = { class: "rgt" }
const _hoisted_22 = { class: "top active" }
const _hoisted_23 = { class: "top" }
const _hoisted_24 = { class: "content-container" }

import {ref,reactive,onMounted,onBeforeUnmount,getCurrentInstance,ComponentInternalInstance,watch,computed} from 'vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'
import {NTooltip } from 'naive-ui'
import UserCenter from '@/components/modules/userCenter/index.vue';
import { getTenantList, getUserKeybinding, getUserJoystickSpecification, saveUserJoystickSpecification } from '@/service'
import { $enum } from '@/global'
import SettingIndex from '@/views/setting/index.vue'
import connectImg from "@assets/images/connect.png"
import disconnectImg from "@assets/images/disconnect.png"
import { ElMessage, ElMessageBox } from 'element-plus'// @ts-ignore
import browser from 'browser-tool'
import {setPause} from '@/webapi'
import { getCanvasLimitHeight } from '@/hooks/useReceiveMessage'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { proxy } = getCurrentInstance() as ComponentInternalInstance
const store = useStore()
const router = useRouter()
const route = useRoute()
const userRef = ref<HTMLDivElement>()
const state = reactive({
  isShowUserInfo:false,
  tenantryList:[],
  remoteID:'',
  romoteCenect:$enum.SWITCH_STATUS.OFF,
  showMultiDeviceModal:false, // 多设备连接选择弹窗
  multiDeviceOptions: [] as { label: string; value: string }[],
  selectedMultiDeviceId:'',
  multiDeviceConfirmLoading:false,
  hardwareList:[] as {text:string,url:string}[],
  showRemoteGuide:false, //遥控器配置引导弹窗
  remoteGuideClosed:false, //遥控器引导弹窗是否已关闭（仅当前会话有效）
  showRemoteSetting:false, //遥控器设置弹窗（飞行页面中使用）
  isReady:false, //三维是否加载完成（从飞行页面广播事件获取）
  pendingPauseOnReady:false, //等待isReady变true后需要暂停三维的标记
  isSimulationPaused:false, //三维是否已暂停（避免重复调用暂停API）
})

// ============ 全屏管理 ============
// 是否处于飞行页面（需要强制保持全屏）
const isInFlightPage = ref(false)
const logoUrl = computed(() => {
  return store.state.viewData.logoUrl;
})
const vkingLogoUrl = computed(() => {
  return require('@/assets/images/vking-figma-logo.png')
})
// 获取浏览器支持的全屏方法
const getRequestFullscreen = (): (() => Promise<void>) | null => {
    const el = document.documentElement as any
    return el.requestFullscreen ||
           el.webkitRequestFullscreen ||
           el.mozRequestFullScreen ||
           el.msRequestFullscreen || null
}

const getExitFullscreen = (): (() => Promise<void>) | null => {
    const doc = document as any
    return doc.exitFullscreen ||
           doc.webkitExitFullscreen ||
           doc.mozCancelFullScreen ||
           doc.msExitFullscreen || null
}

// 判断当前是否处于全屏状态
const isFullscreen = (): boolean => {
    const doc = document as any
    return !!(doc.fullscreenElement ||
              doc.webkitFullscreenElement ||
              doc.mozFullScreenElement ||
              doc.msFullscreenElement)
}

// 进入全屏
const enterFullscreen = () => {
    const requestFn = getRequestFullscreen()
    if (requestFn) {
        requestFn.call(document.documentElement).catch(() => {})
    }
}

// 退出全屏
const exitFullscreen = () => {
    const exitFn = getExitFullscreen()
    if (exitFn) {
        exitFn.call(document).catch(() => {})
    }
}

// 切换全屏
const toggleFullscreen = () => {
  if (isFullscreen()) {
      exitFullscreen()
  } else {
      enterFullscreen()
  }
}

// 监听 F11 按键
const handleFullscreenKeydown = (e: KeyboardEvent) => {
  if (e.key === 'F11') {
      e.preventDefault()
      toggleFullscreen()
  }
}

// 监听路由变化
watch(() => route.path, (path) => {
    const inFlight = path.includes('/flight') && !path.includes('/flight/towerView')
    isInFlightPage.value = inFlight

    if (inFlight) {
        // 进入飞行页面：自动全屏
        if (!isFullscreen()) {
            enterFullscreen()
        }
    } else {
        // 离开飞行页面：自动退出全屏
        if (isFullscreen()) {
            exitFullscreen()
        }
    }
}, { immediate: true })


async function getTenants(){
  let {code , data} = await getTenantList()
  state.tenantryList = []
  if(code == $enum.EnumResult.SUCCESS){
      state.tenantryList =  data as any || []
      let currentTenant:any = null;
      if(Array.isArray(state.tenantryList) && state.tenantryList.length > 0){
        currentTenant =  state.tenantryList[0]
      }
      if(currentTenant && currentTenant.id){
        store.commit('persistence/setCurrentTenantId', currentTenant.id);
      }else{
        store.commit('persistence/setCurrentTenantId', null);
      }
  }
}

async function fetchUserJoystickSpecification() {
  let param = {
    userId: store.state.persistence.userInfo.userId,
    tenantId: store.state.persistence.currentTenantId,
  }
  if (!param.userId || !param.tenantId) {
    return
  }
  const { code, data } = await getUserJoystickSpecification(param) as any
  if (code == $enum.EnumResult.SUCCESS && typeof data === 'string' && data.trim()) {
    store.commit('persistence/setUserTrainingSetting', {
      ...store.state.persistence.userTrainSettingInfo,
      joystickSpecification: data,
    })
  }
}
function mouseLeaveOfUser(): void {
  if(store.state.viewData.isConfirmLogout) return;
  state.isShowUserInfo = false;
}
function switchTenanty():void{
  getTenants()
}
function handleJump(path:string){
  window?.playClick()
  state.isShowUserInfo = false;
  router.push(path)
}

function clickUserIcon():void{
  window?.playClick()
  state.isShowUserInfo = !state.isShowUserInfo
}
// 获取当前连接遥控器的唯一型号列表
function getUniqueConnectedIds(connectedList: Gamepad[]): string[] {
  const ids: string[] = [];
  connectedList.forEach((gp) => {
    if (gp.id && !ids.includes(gp.id)) {
      ids.push(gp.id);
    }
  });
  return ids;
}

// 飞行页面中需要暂停三维时触发
function pauseFlightIfNeeded() {
  if (!route.path.includes('/flight') || state.isSimulationPaused || state.pendingPauseOnReady) {
    return;
  }
  if (state.isReady) {
    pauseFlightSimulation();
  } else {
    state.pendingPauseOnReady = true;
  }
}

// 显示多设备连接选择弹窗
function openMultiDeviceModal(connectedList: Gamepad[]) {
  const uniqueIds = getUniqueConnectedIds(connectedList);
  state.multiDeviceOptions = uniqueIds.map((id) => ({ label: id, value: id }));
  state.selectedMultiDeviceId = uniqueIds[0] || '';
  state.remoteID = state.selectedMultiDeviceId;
  state.romoteCenect = $enum.SWITCH_STATUS.ON;
  state.showRemoteGuide = false;
  state.showMultiDeviceModal = true;
  pauseFlightIfNeeded();
}

// 确认多设备选择
async function handleConfirmMultiDevice() {
  if (!state.selectedMultiDeviceId || state.multiDeviceConfirmLoading) return;

  let param = {
    userId: store.state.persistence.userInfo.userId,
    tenantId: store.state.persistence.currentTenantId,
    joystickSpecification: state.selectedMultiDeviceId,
  }

  state.multiDeviceConfirmLoading = true
  try {
    const { code, data } = await saveUserJoystickSpecification(param) as any
    if (code != $enum.EnumResult.SUCCESS || data !== true) {
      proxy?.vknMessage.error('保存遥控器型号失败！')
      return
    }

    store.commit('persistence/setUserTrainingSetting', {
      ...store.state.persistence.userTrainSettingInfo,
      joystickSpecification: state.selectedMultiDeviceId,
    })
    state.remoteID = state.selectedMultiDeviceId;
    state.romoteCenect = $enum.SWITCH_STATUS.ON;
    state.showMultiDeviceModal = false;
    state.pendingPauseOnReady = false;
    if (route.path.includes('/flight')) {
      resumeFlightSimulation();
    }
    checkRemoteGuide(state.selectedMultiDeviceId);
  } finally {
    state.multiDeviceConfirmLoading = false
  }
}

// 取消多设备选择
function handleCancelMultiDevice() {
  const connectedList = getConnectedGamepads();
  const uniqueIds = getUniqueConnectedIds(connectedList);
  state.showMultiDeviceModal = false;
  state.pendingPauseOnReady = false;
  if (uniqueIds.length) {
    state.remoteID = uniqueIds[0];
    state.romoteCenect = $enum.SWITCH_STATUS.ON;
  }
  if (route.path.includes('/flight')) {
    resumeFlightSimulation();
  }
}
// 获取当前所有已连接的有效遥控器列表
function getConnectedGamepads(): Gamepad[] {
  const gamepads = navigator.getGamepads();
  const connectedList: Gamepad[] = [];
  if (gamepads) {
    for (let i = 0; i < gamepads.length; i++) {
      const gp = gamepads[i];
      if (gp && gp.connected && Array.isArray(gp.axes) && gp.axes.length > 0) {
        connectedList.push(gp);
      }
    }
  }
  return connectedList;
}

function onGamepad(){
  if ('getGamepads' in navigator) {
    const gamepads = navigator.getGamepads();
    if(!gamepads.forEach){
      proxy?.vknMessage.info('您的浏览器不支持Gamepad API,请更换浏览器');
      return;
    }
    // 初始化时检查已连接的遥控器
    const connectedList = getConnectedGamepads();
    if (connectedList.length > 0) {
      handleGamepadsChange();
    }
    window.addEventListener('gamepadconnected', onGamepadConnected);
    window.addEventListener('gamepaddisconnected', gamepaddisconnected);
  } else {
    proxy?.vknMessage.info('您的浏览器不支持Gamepad API,请更换浏览器');
  }
}

// 遥控器连接事件处理
function onGamepadConnected(event: GamepadEvent) {
  handleGamepadsChange();
}

// 统一处理遥控器连接状态变化
function handleGamepadsChange() {
  const connectedList = getConnectedGamepads();
  const count = connectedList.length;

  console.log('当前连接的遥控器数量:', count, connectedList);

  if (count === 0) {
    // 没有遥控器连接
    state.romoteCenect = $enum.SWITCH_STATUS.OFF;
    state.remoteID = '';
    state.showMultiDeviceModal = false;
    state.showRemoteGuide = false;
    state.remoteGuideClosed = false;
    state.pendingPauseOnReady = false;
    state.isSimulationPaused = false;
  } else if (count === 1) {
    // 只有一个遥控器
    state.showMultiDeviceModal = false;
    state.romoteCenect = $enum.SWITCH_STATUS.ON;
    state.remoteID = connectedList[0].id;
    checkRemoteGuide(connectedList[0].id);
  } else {
    // 多个遥控器：展示选择弹窗
    openMultiDeviceModal(connectedList);
  }
}

function gamepaddisconnected (event: any){
  // 拔掉遥控器时，恢复三维（处理弹窗显示期间拔掉的情况）
  if (route.path.includes('/flight') && state.showMultiDeviceModal) {
    if (state.isReady || state.pendingPauseOnReady) {
      resumeFlightSimulation();
    }
  }
  // 统一通过 handleGamepadsChange 处理状态变化
  handleGamepadsChange();
}

// 检测是否需要显示遥控器配置引导弹窗
async function checkRemoteGuide(remoteId: string) {
  // 多设备选择弹窗优先级高于引导弹窗
  if (state.showMultiDeviceModal) return;
  // 用户已去过设置页面，不再显示
  if (state.remoteGuideClosed) return;
  // 已在遥控器设置页面，不显示
  if (route.path.includes('/secondary/setting')) return;
  //设置弹窗页面展示的时候，不显示
  if(state.showRemoteSetting) return;
  // 没有登录，不显示
  const userId = store.state.persistence.userInfo.userId;
  if (!userId) return;

  try {
    const { code, data } = await getUserKeybinding({
      userId: userId,
      deviceType: 1,
      joystickSpecification: remoteId
    }) as any;

    if (code !== $enum.EnumResult.SUCCESS) return;

    // 未配置或未完成校准时，显示引导弹窗
    if (data && !data.configured) {
      state.showRemoteGuide = true;
      // 飞行页面中显示引导弹窗时，暂停三维
      if (route.path.includes('/flight')) {
        if (state.isReady) {
          pauseFlightSimulation();
        } else {
          state.pendingPauseOnReady = true;
        }
      }
    }
  } catch (e) {
    console.error('检测遥控器配置状态失败:', e);
  }
}

// 关闭引导弹窗（不记录状态，刷新后还会再弹）
function handleCloseRemoteGuide() {
  state.showRemoteGuide = false;
  // 飞行页面中关闭引导弹窗时，恢复三维
  if (route.path.includes('/flight')) {
    resumeFlightSimulation();
  }
}

// 跳转到遥控器设置页面（记录状态，之后不再弹窗）
function handleGoToRemoteSetting() {
  state.showRemoteGuide = false;
  state.remoteGuideClosed = true;

  // 判断是否在飞行页面
  const isInFlightPage = route.path.includes('/flight');

  if (isInFlightPage) {
    // 飞行页面中显示全屏设置页面（三维已经在显示引导弹窗时暂停）
    state.showRemoteSetting = true;
  } else {
    // 非飞行页面直接跳转
    handleJump('/secondary/setting');
  }
}

// 暂停三维飞行模拟（供外部调用）
function pauseFlightSimulation() {
  // 如果已经暂停，不再重复调用
  if (state.isSimulationPaused || (!state.showMultiDeviceModal && !state.showRemoteGuide && !state.showRemoteSetting)) return;
  state.isSimulationPaused = true;
  setPause({statu:1})
}

// 恢复三维飞行模拟（供外部调用）
function resumeFlightSimulation() {
  // 如果未暂停，不再调用恢复
  if (!state.isSimulationPaused) return;
  state.isSimulationPaused = false;
  let specifiedJoystick = store.state.persistence.userTrainSettingInfo.joystickSpecification;
  let canvasLimitHeight = getCanvasLimitHeight(store.state.persistence.resolution);
  setPause({statu:0,updateConfig:1,volume:store.state.persistence.sounds.droneSound,specifiedJoystick,canvasLimitHeight})
}

// 处理飞行页面广播的isReady状态变化
function handleIsReadyChange(isReady: boolean) {
  state.isReady = isReady;
  // 如果有等待暂停的标记，且isReady变为true，则执行暂停
  if (isReady && state.pendingPauseOnReady && route.path.includes('/flight')) {
    state.pendingPauseOnReady = false;
    pauseFlightSimulation();
  }
}

// 关闭遥控器设置弹窗
function handleCloseRemoteSetting() {
  state.showRemoteSetting = false;
  // 如果之前在飞行页面，恢复三维
  if (route.path.includes('/flight')) {
    resumeFlightSimulation();
  }
}

// 打开全屏设置页面（供飞行页面设置图标调用）
function handleOpenSettingFullscreen() {
  state.showRemoteSetting = true;
  pauseFlightSimulation();
}

async function getHardwareList(){
  try{
    const info = await browser.getInfo();
    // console.log(info,"info")
    // 浏览器版本判断
    const browserVersion = parseInt(info.browserVersion.split(".")[0])
    const browserWarn={
      text:'当前浏览器版本过低：',
      url:'/ppt/browser.pdf',
    };
    if(info.browser==='Edge'){
      if(browserVersion<90){
        state.hardwareList.push(browserWarn)
      }
    }else if(info.browser==='Firefox'){
      if(browserVersion<97){
        state.hardwareList.push(browserWarn)
      }
    }else if(info.browser==='Chrome'){
      if(browserVersion<96){
        state.hardwareList.push(browserWarn)
      }
    }else if(info.browser==='360SE'){
      if(browserVersion<10){
        state.hardwareList.push(browserWarn)
      }else if(browserVersion===10){
        const version2 = info.browserVersion.split(".")[1]
        const version3 = info.browserVersion.split(".")[2]
        const version4 = info.browserVersion.split(".")[3]
        if(version2){
          if(parseInt(version2)===0){
            state.hardwareList.push(browserWarn)
          }else if(parseInt(version2)===1){
            if(!version3){
              state.hardwareList.push(browserWarn)
            }else if(parseInt(version3)===0){
              state.hardwareList.push(browserWarn)
            }else if(parseInt(version3)===1){
              if(!version4){
                state.hardwareList.push(browserWarn)
              }else if(parseInt(version3)<260){
                state.hardwareList.push(browserWarn)
              }
            }
          }
        }else{
          state.hardwareList.push(browserWarn)
        }
      }
    }else{
      state.hardwareList.push(browserWarn)
    }

    // 独立显卡判断
    const gpuWarn={
      text:'未检测到独立显卡：',
     url:'/ppt/gpu.pdf',
    };
    const gpu =  getGpuType(info.gpuModel);
    if(gpu!=='独立显卡'){
      state.hardwareList.push(gpuWarn)
    }
  }catch(e){
    console.log(e,"出错了")
  }
}

function getGpuType(gpuModel:string) {
  const model = gpuModel.toLowerCase();
  if (model.includes("intel")) {
    return "集成显卡";
  }
  if (model.includes("amd") || model.includes("radeon")) {
    // APU (CPU+GPU) 一般算集成显卡
    if (model.includes("vega") || model.includes("apu")) {
      return "集成显卡";
    }
    return "独立显卡";
  }
  if (model.includes("nvidia") || model.includes("geforce") || model.includes("rtx") || model.includes("gtx") || model.includes("quadro")) {
    return "独立显卡";
  }
  return "未知";
}

function handleClickOutside(event: any) {
  if(userRef.value && !userRef.value.contains(event.target)){
    state.isShowUserInfo = false;
  }
}

onMounted(async () => {
  onGamepad()
  await getTenants()
  fetchUserJoystickSpecification()
  getHardwareList()
  document.addEventListener('click', handleClickOutside);
  // 监听关闭遥控器设置弹窗事件
  window.listenEvent.on('close-remote-setting', handleCloseRemoteSetting);
  // 监听打开全屏设置页面事件
  window.listenEvent.on('open-setting-fullscreen', handleOpenSettingFullscreen);
  // 监听切换全屏事件
  window.listenEvent.on('toggle-full-screen', toggleFullscreen);
  // 监听飞行页面广播的isReady状态变化
  window.listenEvent.on('is-ready-change', handleIsReadyChange);
  // 全屏管理事件监听
  document.addEventListener('keydown', handleFullscreenKeydown)
});

onBeforeUnmount(()=>{
  ElMessageBox.close();
  state.isShowUserInfo = false;
  window.removeEventListener('gamepadconnected', onGamepadConnected);
  window.removeEventListener('gamepaddisconnected', gamepaddisconnected);
  document.removeEventListener('click', handleClickOutside);
  window.listenEvent.off('close-remote-setting', handleCloseRemoteSetting);
  window.listenEvent.off('open-setting-fullscreen', handleOpenSettingFullscreen);
  window.listenEvent.off('toggle-full-screen', toggleFullscreen);
  window.listenEvent.off('is-ready-change', handleIsReadyChange);
  // 移除全屏管理事件监听
  document.removeEventListener('keydown', handleFullscreenKeydown)
  // 离开时退出全屏
  if (isFullscreen()) {
    exitFullscreen()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("img", {
              src: vkingLogoUrl.value,
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          (logoUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: logoUrl.value,
                alt: "",
                crossorigin: "anonymous"
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (state.hardwareList.length>0)
            ? (_openBlock(), _createBlock(_component_el_carousel, {
                key: 1,
                direction: "vertical",
                class: "carousel",
                "indicator-position": "none",
                interval: "5000"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.hardwareList, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                      key: index,
                      class: "item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_vkm_svg, {
                            "icon-name": "warn",
                            class: "icon"
                          }),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.text), 1)
                        ]),
                        _createElementVNode("a", {
                          href: item.url,
                          target: "_blank"
                        }, "解决方案>", 8, _hoisted_10)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "remote-control",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleJump('/secondary/setting')))
        }, [
          _createElementVNode("img", {
            src: state.romoteCenect? _unref(connectImg):_unref(disconnectImg)
          }, null, 8, _hoisted_11),
          (state.romoteCenect)
            ? (_openBlock(), _createBlock(_unref(NTooltip), {
                key: 0,
                trigger: "hover"
              }, {
                trigger: _withCtx(() => [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(state.remoteID), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(state.remoteID), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("p", _hoisted_14, "未连接遥控器"))
        ]),
        (state.showMultiDeviceModal)
          ? (_openBlock(), _createBlock(_component_vkm_modal, {
              key: 0,
              class: "multi-device-modal-container prompt-modal-container",
              title: "提示",
              isShowCloseIcon: false,
              style: {"z-index":"9998"}
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "multi-device-text" }, "检测到你连接了多个可用设备，请选择需要使用的设备。", -1)),
                  _createVNode(_component_el_select, {
                    modelValue: state.selectedMultiDeviceId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.selectedMultiDeviceId) = $event)),
                    placeholder: "请选择设备",
                    teleported: false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.multiDeviceOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_vkn_button, {
                    label: "取消",
                    type: "info",
                    size: "medium",
                    disabled: state.multiDeviceConfirmLoading,
                    onClick: handleCancelMultiDevice
                  }, null, 8, ["disabled"]),
                  _createVNode(_component_vkn_button, {
                    label: "确定",
                    type: "primary",
                    size: "medium",
                    loading: state.multiDeviceConfirmLoading,
                    onClick: handleConfirmMultiDevice
                  }, null, 8, ["loading"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (state.showRemoteGuide)
          ? (_openBlock(), _createBlock(_component_vkm_modal, {
              key: 1,
              class: "prompt-modal-container",
              title: "提示",
              isShowCloseIcon: false,
              style: {"z-index":"9996"}
            }, {
              content: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "prompt-content" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }),
                  _createElementVNode("p", { class: "prompt-text" }, "检测到你的遥控器可能未设置和校准，请前往设置")
                ], -1)
              ])),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_vkn_button, {
                    label: "取消",
                    type: "info",
                    size: "medium",
                    onClick: handleCloseRemoteGuide
                  }),
                  _createVNode(_component_vkn_button, {
                    label: "去设置",
                    type: "primary",
                    size: "medium",
                    onClick: handleGoToRemoteSetting
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (state.showRemoteSetting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_vkm_svg, {
                  "icon-name": "back",
                  class: "icon",
                  onClick: handleCloseRemoteSetting
                }),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, "设置", -1))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(SettingIndex)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", {
          class: "rgt-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleJump('/secondary/grade')))
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "nav_cj",
              class: "icon"
            })
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "成绩", -1))
        ]),
        _createElementVNode("div", {
          class: "rgt-item",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleJump('/secondary/setting')))
        }, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "nav_sz",
              class: "icon"
            })
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "设置", -1))
        ]),
        _createElementVNode("div", {
          class: "rgt-item",
          ref_key: "userRef",
          ref: userRef,
          onMouseleave: mouseLeaveOfUser
        }, [
          _createElementVNode("div", {
            class: "top",
            onClick: clickUserIcon
          }, [
            _createVNode(_component_vkm_svg, {
              "icon-name": "nav_yh",
              class: "icon"
            })
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("span", null, "用户", -1)),
          _withDirectives(_createVNode(UserCenter, {
            tenantList: state.tenantryList,
            isClose: state.isShowUserInfo,
            onOnSwitchTenanty: switchTenanty
          }, null, 8, ["tenantList", "isClose"]), [
            [_vShow, state.isShowUserInfo]
          ])
        ], 544)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      (_openBlock(), _createBlock(_component_router_view, {
        key: _unref(route).fullPath
      }))
    ])
  ]))
}
}

})